<template>
  <withTopNav :leftText="$t('Activities.Agentcenter.AgentDetail.Title')" fixed>
    <div
      class="flex items-center justify-end absolute right-2 top-[18px] z-10"
      @click="
        () => {
          dateFilterModal = true;
        }
      "
    >
      <span class="text-[#fff]">{{
        showTimeText || $t("Activities.Agentcenter.AgentDetail.Filter")
      }}</span>
      <img class="w-3 ml-1 rotate-90" :src="arrow_bai" alt="" />
    </div>

    <div class="w-full px-4">
      <div class="flex items-center justify-between mt-6 relative">
        <input
          v-model="form.userId"
          class="w-full h-[48px] text-[14px] rounded-lg placeholder:text-[#85898D] placeholder:text-[14px] !bg-[#2C3235] px-4 border-none outline-none forced-colors:!bg-[#2C3235]"
          clearable
          @clear="onClear"
          :placeholder="$t('Activities.Agentcenter.AgentDetail.SearchPlaceholder')"
        />
        <span
          :class="[
            'absolute right-[5px] top-[3px] !bg-[#FFDF12] ml-2 text-center text-black/65 py-2.5 px-5 rounded-lg',
          ]"
        >
          <img :src="search" @click="form.userId && onSearch()" class="w-5" alt="" />
        </span>
      </div>
      <div class="mt-4">
        <van-pull-refresh
          v-model="loading"
          @refresh="queryAgentDetail(showTimeText, form.userId)"
          :pulling-text="$t('Activities.Agentcenter.AgentDetail.WaitingForQuery')"
          :loosing-text="$t('Activities.Agentcenter.AgentDetail.WaitingForQuery')"
          :success-text="$t('Activities.Agentcenter.AgentDetail.WaitingForQuery')"
        >
          <template #loading>
            <div></div>
          </template>

          <div v-if="!loading" class="w-full rounded-lg">
            <template v-if="agentDetail.userid">
              <div class="flex items-center justify-start mt-5">
                <img
                  :src="`/static/images/avatar/${agentDetail?.avatarUrl || '/02.png'}`"
                  alt=""
                  class="w-16 h-16 rounded-full bg-white mr-2"
                />
                <div class="flex items-start justify-center flex-col flex-1">
                  <h3 class="text-[17px] text-[#fff] font-bold">
                    {{ agentDetail?.username || "-----" }}
                  </h3>
                  <div class="flex items-center justify-between w-full">
                    <div class="flex items-start justify-center flex-col">
                      <span class="text-[#fff]/75 text-[13px]">
                        ID: {{ agentDetail?.userid }}
                      </span>
                      <span class="text-[#FFDF12] text-[13px] font-[500]">
                        {{
                          agentDetail?.agentLevel == "General"
                            ? $t("Activities.Agentcenter.AgentDetail.AgentGeneral")
                            : $t("Activities.Agentcenter.AgentDetail.AgentLevel", {
                                level: agentDetail?.agentLevel,
                              })
                        }}
                      </span>
                    </div>
                    <div
                      v-if="agentDetail?.parentId && activeUserid !== agentDetail?.userid"
                      @click="onNextGentId(agentDetail?.parentId)"
                      class="flex px-3 py-2 bg-[#2C7952]/70 rounded-lg flex-col text-xs text-white items-center justify-center"
                    >
                      <span class="flex items-center justify-center text-[11px]">
                        {{ $t("Activities.Agentcenter.AgentDetail.SuperiorAgent") }}
                        <img class="w-2 ml-1" :src="arrow_bai" alt="" />
                      </span>
                      <span class="text-[11px] mt-1"
                        >ID: {{ agentDetail?.parentId }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-[#FFFFFFBF] text-[11px] mt-2">
                {{ $t("Activities.Agentcenter.AgentDetail.RegistrationDate") }}
                {{ formatDateInPortuguese(agentDetail?.registrationTime) }}
              </div>
              <template v-if="agentDetail?.currentUserDetail">
                <div class="mt-5">
                  <ul
                    class="flex items-center justify-center gap-px h-[80px] text-center"
                  >
                    <li
                      class="h-full flex-1 rounded-tl-3xl flex flex-col py-2 items-center justify-center bg-[#2C7952]/40"
                    >
                      <span class="font-bold text-[#FFFFFF] text-[15px]">
                        {{
                          formatter().format(
                            agentDetail.currentUserDetail?.userContributionCommission || 0
                          )
                        }}
                      </span>
                      <span class="text-[#fff]/50 text-[12px] font-[500]">
                        {{ $t("Activities.Agentcenter.AgentDetail.ProvideIncome") }}
                      </span>
                    </li>
                    <li
                      class="h-full flex-1 flex flex-col py-2 items-center justify-center bg-[#2C7952]/40"
                    >
                      <span class="font-bold text-[#FFFFFF] text-[15px]">
                        {{
                          formatter().format(
                            agentDetail.currentUserDetail?.userDeposit || 0
                          )
                        }}
                      </span>
                      <span class="text-[#fff]/50 text-[12px] font-[500]">
                        {{ $t("Activities.Agentcenter.AgentDetail.Deposit") }}
                      </span>
                    </li>
                    <li
                      class="h-full flex-1 rounded-tr-3xl flex flex-col py-2 items-center justify-center bg-[#2C7952]/40"
                    >
                      <span class="font-bold text-[#FFFFFF] text-[15px]">
                        {{
                          formatter().format(
                            agentDetail.currentUserDetail?.userWithdrawal || 0
                          )
                        }}
                      </span>
                      <span class="text-[#fff]/50 text-[12px] font-[500]">
                        {{ $t("Activities.Agentcenter.AgentDetail.Withdrawal") }}
                      </span>
                    </li>
                  </ul>
                  <ul
                    class="flex items-center justify-center gap-px mt-px h-[80px] text-center"
                  >
                    <li
                      class="h-full flex-1 rounded-bl-3xl flex flex-col py-2 items-center justify-center bg-[#2C7952]/20"
                    >
                      <span class="font-bold text-[#FFFFFF] text-[15px]">
                        {{ formatter().format(agentDetail.currentInfo?.userBet || 0) }}
                      </span>
                      <span class="text-[#fff]/50 text-[12px] font-[500]">
                        {{ $t("Activities.Agentcenter.AgentDetail.Bet") }}
                      </span>
                    </li>
                    <li
                      class="h-full flex-1 flex flex-col py-2 items-center justify-center bg-[#2C7952]/20"
                    >
                      <span
                        :class="[
                          'font-bold text-[#FFFFFF] text-[15px]',
                          {
                            'text-[#FF3B30]':
                              Number(agentDetail.currentUserDetail?.userWinLoss) < 0,
                          },
                        ]"
                      >
                        {{ showNumber(agentDetail.currentUserDetail?.userWinLoss || 0) }}
                      </span>
                      <span class="text-[#fff]/50 text-[12px] font-[500]">
                        {{ $t("Activities.Agentcenter.AgentDetail.ProfitAndLoss") }}
                      </span>
                    </li>
                    <li
                      class="h-full flex-1 rounded-br-3xl flex flex-col py-2 items-center justify-center bg-[#2C7952]/20"
                    >
                      <span class="font-bold text-[#FFFFFF] text-[15px]">
                        {{
                          formatter().format(
                            agentDetail.currentUserDetail?.userActivityGift || 0
                          )
                        }}
                      </span>
                      <span
                        class="text-[#fff]/50 text-[12px] font-[500] break-words inline-block w-3/5"
                      >
                        {{ $t("Activities.Agentcenter.AgentDetail.GiftMoney") }}
                      </span>
                    </li>
                  </ul>
                </div>
              </template>
              <TableList
                :title="$t('Activities.Agentcenter.AgentDetail.SubordinateData')"
              >
                <ul
                  class="flex items-center justify-center gap-px h-[92px] mt-px text-center"
                >
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.userContributionCommission ||
                            0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.CommissionIncome") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerAgentNum || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.Subordinates") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.registrationNum || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.Registrations") }}
                    </span>
                  </li>
                </ul>
                <ul
                  class="flex items-center justify-center gap-px h-[92px] mt-px text-center"
                >
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/20"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerFirstRechargeAmount || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.FirstDeposit") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/20"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerDeposit || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.SubordinateRecharge") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/20"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerWithdrawalAmount || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.Withdrawal") }}
                    </span>
                  </li>
                </ul>
                <ul
                  class="flex items-center justify-center gap-px mt-px h-[92px] text-center"
                >
                  <li
                    class="h-full flex-1 rounded-bl-3xl flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerBetAmount || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.SubordinateBets") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span
                      :class="[
                        'font-bold text-[#FFFFFF] text-[15px]',
                        {
                          'text-[#FF3B30]':
                            Number(
                              agentDetail.agentTeamMemberDetail?.lowerWinLossAmount
                            ) < 0,
                        },
                      ]"
                    >
                      {{
                        showNumber(
                          agentDetail.agentTeamMemberDetail?.lowerWinLossAmount || 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[12px] font-[500]">
                      {{ $t("Activities.Agentcenter.AgentDetail.ProfitAndLoss") }}
                    </span>
                  </li>
                  <li
                    class="h-full flex-1 rounded-br-3xl flex flex-col py-5 items-center justify-center bg-[#2C7952]/40"
                  >
                    <span class="font-bold text-[#FFFFFF] text-[15px]">
                      {{
                        formatter().format(
                          agentDetail.agentTeamMemberDetail?.lowerActivityAmount || 0
                        )
                      }}
                    </span>
                    <span
                      class="text-[#fff]/50 text-[12px] font-[500] break-words inline-block w-3/5"
                    >
                      {{ $t("Activities.Agentcenter.AgentDetail.Gifts") }}
                    </span>
                  </li>
                </ul>
              </TableList>
            </template>
            <template v-else>
              <NoData :text="$t('Activities.Agentcenter.AgentDetail.NoDataText')" />
            </template>
          </div>
          <div v-else class="w-full h-[300px] flex-center flex-col rounded-lg">
            <img
              class="w-10 h-10"
              :src="reate"
              alt=""
              :class="{ 'animate-spin': loading }"
            />
            <span class="text-[#fff]/50 text-[13px] mt-4 block">{{
              $t("Activities.Agentcenter.AgentDetail.WaitingForQuery")
            }}</span>
          </div>
        </van-pull-refresh>
      </div>
    </div>

    <!-- 日期筛选模态框 -->
    <van-popup
      v-model:show="dateFilterModal"
      position="bottom"
      :lock-scroll="false"
      class="w-full bg-[#151A1F] bottom-0 rounded-t-[24px]"
    >
      <div
        class="w-full h-[44px] text-[15px] flex justify-center items-center bg-[#2C7952]/70 text-[#fff] sticky top-0 rounded-t-[10px]"
      >
        <span>{{ $t("Activities.Agentcenter.AgentDetail.FilterConditions") }}</span>
      </div>
      <p class="text-[#fff] text-[15px] mt-[10px] px-[40px]">
        {{ $t("Activities.Agentcenter.AgentDetail.SelectTime") }}
      </p>
      <div class="px-[30px] flex justify-between flex-wrap mt-[10px] gap-y-[10px]">
        <button
          v-for="item in options"
          :key="item.value"
          @click="showTimeText = item.label"
          :class="[
            'w-[150px] h-[44px] text-[13px] rounded-[8px] border-0',
            showTimeText === item.label
              ? 'bg-[#2C7952]/40 text-[#fff]'
              : 'bg-[#2C7952]/20 text-[#fff]/65',
          ]"
        >
          {{ item.label }}
        </button>
      </div>

      <div class="mx-[30px] my-8">
        <PopupFooter
          :onCancel="() => (dateFilterModal = false)"
          :onConfirm="
            () => {
              dateFilterModal = false;
              currentDate = options.find((item) => item.label === showTimeText);
              queryAgentDetail(currentDate.label, form.userId);
            }
          "
        />
      </div>
    </van-popup>
  </withTopNav>
</template>

<script setup lang="tsx">
import { getAgentTeamInfo } from "@/api/agent";
import withTopNav from "@/layouts/withTopNav.vue";
import NoData from "@/components/NoData/index.vue";
import arrow_bai from "./images/arrow_bai.png";
import search from "./images/search.png";
import reate from "./images/reate.png";
import TableList from "./../components/TableList.vue";
import PopupFooter from "@a/components/PopupFooter/index.vue";
import { debounce } from "lodash-es";
import { useUserInfo } from "@/store";
import { getDateRange, formatDateInPortuguese, formatter } from "@/utils";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const activeUserid = computed(() => useUserInfo().userInfo?.userid);
const { t } = useI18n();
const agentUserid = useRoute().query.agentUserid as string;
const showTimeText = ref<string>(t("Activities.Agentcenter.AgentDetail.Today"));
const form = ref<any>({});
const loading = ref(false);
const customizeDate = ref<any>([]);
const agentDetail = ref<any>({
  currentUserDetail: {},
  agentTeamMemberDetail: {},
});

const dateFilterModal = ref(false);
const currentDate = ref<any>({});

const options = [
  {
    label: t("Activities.Agentcenter.AgentDetail.Today"),
    value: "1",
  },
  {
    label: t("Activities.Agentcenter.AgentDetail.Yesterday"),
    value: "2",
  },
  {
    label: t("Activities.Agentcenter.AgentDetail.ThisWeek"),
    value: "3",
  },
  {
    label: t("Activities.Agentcenter.AgentDetail.ThisMonth"),
    value: "4",
  },
  {
    label: t("Activities.Agentcenter.AgentDetail.LastMonth"),
    value: "5",
  },
  {
    label: t("Activities.Agentcenter.AgentDetail.LastThreeMonths"),
    value: "6",
  },
];
// 代理详情
const queryAgentDetail = async (timeValue?: any, agentUserid?: string) => {
  let time: any;
  if (showTimeText.value === "Customizado") {
    time = customizeDate;
  }
  if (typeof timeValue === "string" && timeValue !== "Customizado") {
    time = getDateRange(timeValue);
  }

  if (Array.isArray(timeValue)) {
    time = timeValue;
  }
  const parmas = {
    startTime: time[0],
    endTime: time[1],
    agentUserid: agentUserid || activeUserid.value,
  };
  loading.value = true;
  const { code, data } = await getAgentTeamInfo(parmas);
  loading.value = false;
  if (code === 1) {
    agentDetail.value = data;
  }
};

// 下一级代理id
const onNextGentId = async (id: string) => {
  form.value.userId = id;
  queryAgentDetail(showTimeText.value, id);
};

const onSearch = debounce(() => {
  queryAgentDetail(showTimeText.value, form.value.userId);
}, 800);

const onClear = () => {
  form.value.userId = "";
  queryAgentDetail(showTimeText.value);
};

// 显示正负数
const showNumber = (value: number) => {
  if (value > 0) {
    return `+${formatter().format(value)}`;
  } else if (value < 0) {
    return `${formatter().format(value)}`;
  } else {
    return formatter().format(value);
  }
};

onMounted(() => {
  if (agentUserid) {
    form.value.userId = agentUserid;
    queryAgentDetail("Hoje", agentUserid);
  } else {
    queryAgentDetail("Hoje");
  }
});
</script>

<style scoped lang="scss"></style>
